import React from 'react'
import VisarjanSeva from './VisarjanSeva';
import LazySection from '../Home/LazySection';
import DarshanBookingBannerImg from "../../assets/images/new/DarshanBookingBannerImg.png";
const GanapatiVisarjanLandingPage = () => {
    const handleScroll = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };
    return (
        <div>
            <section className="page-header">
                <div
                    className="page-header__bg_serviceBanner"
                    style={{ backgroundImage: `url(${DarshanBookingBannerImg})` }}
                ></div>
                <div className="container">
                    <h1
                        className="page-header__title bw-split-in-left"
                    // onClick={ExitIntenModalOpen}
                    >
                        Ganapati Visarjan
                    </h1>
                </div>
            </section>
            <div className=" p-4">
                {/* Page Title */}
                <h2 className="text-center fw-bold mb-4">
                    The Ganesh Visarjan Story, Muhurat and Puja Vidhi Guide
                </h2>

                {/* Banner Image */}
                <div className="text-center mb-4">
                    <img
                        src="https://shreeganesh.com/site/wp-content/uploads/2022/06/ganesh-chaturthi1.jpg" // replace with your image path
                        alt="Ganesh Visarjan"
                        className="img-fluid rounded shadow"
                        style={{ maxHeight: "350px", objectFit: "cover" }}
                    />
                </div>

                {/* Navigation Cards */}
                <div className="row g-3 mb-5">
                    <div className="col-12 col-md-6">
                        <button
                            className="btn w-100 text-start border rounded p-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleScroll("muhurat")}
                        >
                            Ganesh Visarjan 2025 Muhurat Timings <span>▶</span>
                        </button>
                    </div>
                    <div className="col-12 col-md-6">
                        <button
                            className="btn w-100 text-start border rounded p-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleScroll("story")}
                        >
                            The Story Behind Ganesh Visarjan <span>▶</span>
                        </button>
                    </div>
                    <div className="col-12 col-md-6">
                        <button
                            className="btn w-100 text-start border rounded p-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleScroll("stepguide")}
                        >
                            Step by Step Guide to Ganesh Visarjan Puja <span>▶</span>
                        </button>
                    </div>
                    <div className="col-12 col-md-6">
                        <button
                            className="btn w-100 text-start border rounded p-3 d-flex justify-content-between align-items-center"
                            onClick={() => handleScroll("proceedToBook")}
                        >
                            Proceed to book <span>▶</span>
                        </button>
                    </div>
                </div>

                {/* Content Section */}
                <div className="mb-5">
                    <p>
                        Lord Ganesha is the symbol of the Hindu religion. He is also known as Ganapati Bappa or Ganpadev.
                        People enjoy the festival of Ganesh Chaturthi in his honor. They bring huge idols home with
                        affectionate devotion and celebration. The ten-day festival ends on the last day called Anant Chaturdashi.
                        On this day, devotees bid farewell to Lord Ganesha and immerse his idols into rivers, seas, or lakes.
                        This is known as Ganesh Visarjan, which means sending Bappa back to his true abode in Kailash.
                    </p>
                    <p>
                        Ganesh Visarjan has a deep spiritual meaning. It symbolizes the cycle of creation and dissolution in life.
                        People chant Ganpati Bappa Morya during immersion with prayers for removing obstacles, success, and happiness.
                        Every year, Ganesh devotees across India celebrate the festival with immense devotion, grand processions,
                        and joyous songs.
                    </p>
                </div>

                {/* Muhurat Section */}
                <h3 className="fw-bold mb-3">Ganesh Visarjan 2025 Muhurat Timings</h3>
                <p>
                    People offer the final farewell to Ganesha’s idol on Anant Chaturdashi. Below are the auspicious timings
                    (Muhurat) for Ganesh Visarjan 2025.
                </p>

                {/* Timing Table */}
                <div id="muhurat" className="table-responsive">
                    <table className="table table-bordered text-center">
                        <thead className="table-light">
                            <tr>
                                <th>Event</th>
                                <th>Date</th>
                                <th>Timing</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Ganesh Visarjan on Anant Chaturdashi</td>
                                <td>Saturday, 6 September 2025</td>
                                <td>05:57 AM - 08:47 AM</td>
                            </tr>
                            <tr>
                                <td>Morning Muhurat</td>
                                <td>Sep 06</td>
                                <td>06:57 AM - 08:57 AM</td>
                            </tr>
                            <tr>
                                <td>Afternoon Muhurat</td>
                                <td>Sep 06</td>
                                <td>01:25 PM - 03:45 PM</td>
                            </tr>
                            <tr>
                                <td>Evening Muhurat</td>
                                <td>Sep 06</td>
                                <td>06:45 PM - 09:15 PM</td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                {/* Story behind Visarjan */}
                <div id="story">
                    <h3 className="fw-bold mb-3">The Story Behind Ganesh Visarjan</h3>
                    <p>
                        Lord Ganesha’s devotees shout Ganpati Bappa Morya with a lot of energy at the time of Ganesh immersion or Ganesh Visarjan at home. They also recite Ganpati Stotram while doing Ganpati Visarjan at home and outside. People don’t want to miss out on the final glimpse of their beloved Lord Ganesha at the time of Ganesh Ji Visarjan. With all the loud bands and Ganesh Bhajans, devotees reach the place of Visarjan to say good-bye to Lord Ganesha.
                    </p>
                    <p>
                        Ganesh Visarjan is performed to symbolise the form and life of Lord Ganesha. He was born out of clay, and the Ganesh idols are also made out of clay. Devotees immerse the idol of Lord Ganesha in the water bodies on the day of Anant Chaturdashi. Visarjan is performed so that Lord Ganesha can go back to his home.
                    </p>
                </div>


                {/* Step By Step guidance */}
                <div id="stepguide">
                    <h3 className="fw-bold mb-3">Step by Step Guide to Ganesh Visarjan Puja</h3>
                    <p>
                        The Puja Vidhi is a way to bid farewell to the most beloved god of the devotees, Lord Ganesha. People do Lord Ganesha Puja for Ganesh Visarjan by following these steps:
                    </p>
                    <p>
                        <ol className="list-group list-group-numbered">
                            <li className="list-group-item">
                                The Puja starts with Lord Ganesha’s Aarti in the early morning with the entire family and relatives present.
                            </li>
                            <li className="list-group-item">
                                Devotees use <strong>Modak</strong>, a home-cooked sweet, for the Prasad and offer flowers to Lord Ganesha.
                            </li>
                            <li className="list-group-item">
                                After the Aarti, people march towards the Visarjan venue and pick up Lord Ganesha’s idol.
                                First move it towards yourself, signifying that Visarjan time has come.
                            </li>
                            <li className="list-group-item">
                                Pray to Lord Ganesha and express gratitude for staying at your home and solving your worries and problems.
                            </li>
                            <li className="list-group-item">
                                Take some <strong>Akshat</strong> (rice without oil) and offer it to Lord Ganesha.
                                Also, put some <strong>Dahi</strong> on his hands for good luck.
                            </li>
                            <li className="list-group-item">
                                Tie a red cloth with coconut, jaggery, and grains in it. This is the meal that’ll satisfy Lord Ganesha’s hunger during his trip back home.
                            </li>
                            <li className="list-group-item">
                                Sprinkle water on the person who performs the Puja Vidhi for Ganapati Visarjan.
                            </li>
                            <li className="list-group-item">
                                Give a final tour of your home to Lord Ganesha before leaving. It signifies his grace and blessings remain with you.
                            </li>
                            <li className="list-group-item">
                                Recite mantras and chant <strong>“Ganpati Bappa Morya”</strong> with devotion and energy.
                            </li>
                            <li className="list-group-item">
                                While leaving home, another person should hold a coconut. Offer it to Ganpati Bappa and break it in one go.
                            </li>
                            <li className="list-group-item">
                                Immerse the coconut along with Lord Ganesha’s idol.
                            </li>
                            <li className="list-group-item">
                                Perform Ganesh Aarti one last time at the Visarjan venue.
                            </li>
                            <li className="list-group-item">
                                Remove decorations from Lord Ganesha’s idol and dispose of them properly.
                                Then complete Ganesh Visarjan by immersing the idol in the water body.
                            </li>
                        </ol>
                    </p>

                </div>

                <div id='proceedToBook'>

                    <LazySection> <VisarjanSeva /></LazySection>
                </div>
            </div>
        </div>
    )
}

export default GanapatiVisarjanLandingPage
